import { render, staticRenderFns } from "./MaterialExam.vue?vue&type=template&id=1f1c9f88&scoped=true&"
import script from "./MaterialExam.vue?vue&type=script&lang=js&"
export * from "./MaterialExam.vue?vue&type=script&lang=js&"
import style0 from "./MaterialExam.vue?vue&type=style&index=0&id=1f1c9f88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1c9f88",
  null
  
)

export default component.exports